// extracted by mini-css-extract-plugin
export default {"helpText":"TopicUserSelect-module__helpText--xXt_L","select":"TopicUserSelect-module__select--xvYEw","animatedBackground":"TopicUserSelect-module__animatedBackground--QQeK7"};